import React from 'react';
import GroupTable from 'components/UiKit/GroupTable';
import PropTypes from 'prop-types';
import { mapFarmView } from '../../../utilities/changeSummaryTools';
import CropZoneCell from '../CropZoneCell';

const farmViewDefaultPropMassiveChangeSummary = {};
const FarmView = ({
  massiveChangeSummary = farmViewDefaultPropMassiveChangeSummary
}) => {
  const mappedFarmView = mapFarmView(
    massiveChangeSummary.fieldsToMassiveAssign
  );

  return (
    <GroupTable>
      {Object.entries(mappedFarmView).map(farm => (
        <GroupTable.RowGroup arrowIcon key={farm[0]}>
          <GroupTable.Row>
            <GroupTable.Cell>
              <p className="font-semibold font-body">{farm[0]}</p>
            </GroupTable.Cell>
          </GroupTable.Row>
          {farm[1].map(property => {
            return (
              <GroupTable.RowGroup arrowIcon key={property.id}>
                <GroupTable.Row>
                  <GroupTable.Cell>
                    <p className="font-semibold font-body">{property.name}</p>
                  </GroupTable.Cell>
                </GroupTable.Row>
                <GroupTable.Row>
                  <GroupTable.Cell>
                    <CropZoneCell
                      massiveChangeSummary={massiveChangeSummary}
                      property={property}
                      key={property.id}
                    />
                  </GroupTable.Cell>
                </GroupTable.Row>
              </GroupTable.RowGroup>
            );
          })}
        </GroupTable.RowGroup>
      ))}
    </GroupTable>
  );
};

FarmView.propTypes = {
  massiveChangeSummary: PropTypes.shape()
};

export default FarmView;
